"use client";
import React, { useState } from "react";
import { MainTitle } from "../common/MainTitle";
import LogoFirst from "/public/almarai.svg";
import LogoSec from "/public/amazon.svg";
import LogoThird from "/public/apple.svg";
import LogoFourth from "/public/cadbury.svg";
import LogoFifth from "/public/coca-cola.svg";
import LogoSixth from "/public/amcor.svg";
import LogoSeventh from "/public/colgate.svg";
import LogoEight from "/public/daimler.svg";
import LogoNineth from "/public/dairy.svg";
import LogoTenth from "/public/diageo.svg";
import LogoEleventh from "/public/heinz.svg";
import LogoTwelth from "/public/hitachi.svg";
import LogoThirteen from "/public/honda.svg";
import LogoFourteen from "/public/huhtam.svg";
import LogoFifteen from "/public/itc.svg";
import LogoSixteen from "/public/jotun.svg";
import LogoSeventeen from "/public/lg.svg";
import LogoEighteen from "/public/nest.svg";
import LogoNineteen from "/public/panasonic.svg";
import LogoTwenty from "/public/pepsi.svg";
import LogoTwentyOne from "/public/procter.svg";
import LogoTwentyTwo from "/public/reckitt.svg";
import LogoTwentyThree from "/public/unilever.svg";
import Slider from "react-slick";
import Image from "next/image";
import Map from "./Map";

function SampleNextArrow(any: { className: any; style: any; onClick: any }) {
  const { className, style, onClick } = any;
  return (
    <div
      className={className}
      style={{
        ...style,
        position: "absolute",
        right: "2%",
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(any: { className: any; style: any; onClick: any }) {
  const { className, style, onClick } = any;
  return (
    <div
      className={className}
      style={{ ...style, position: "absolute", left: "2%", zIndex: "9" }}
      onClick={onClick}
    />
  );
}

const imageData = [
  { id: 1, src: LogoFirst, alt: "almarai" },
  { id: 2, src: LogoSec, alt: "amazon" },
  { id: 3, src: LogoThird, alt: "apple" },
  { id: 4, src: LogoFourth, alt: "cadbury" },
  { id: 5, src: LogoFifth, alt: "coca-cola" },
  { id: 6, src: LogoSixth, alt: "amcor" },
  { id: 7, src: LogoSeventh, alt: "amcor" },
  { id: 8, src: LogoEight, alt: "amcor" },
  { id: 9, src: LogoNineth, alt: "amcor" },
  { id: 10, src: LogoTenth, alt: "amcor" },
  { id: 11, src: LogoEleventh, alt: "amcor" },
  { id: 12, src: LogoTwelth, alt: "amcor" },
  { id: 13, src: LogoThirteen, alt: "amcor" },
  { id: 14, src: LogoFourteen, alt: "amcor" },
  { id: 15, src: LogoFifteen, alt: "amcor" },
  { id: 16, src: LogoSixteen, alt: "amcor" },
  { id: 17, src: LogoSeventeen, alt: "amcor" },
  { id: 18, src: LogoEighteen, alt: "amcor" },
  { id: 19, src: LogoNineteen, alt: "amcor" },
  { id: 20, src: LogoTwenty, alt: "amcor" },
  { id: 21, src: LogoTwentyOne, alt: "amcor" },
  { id: 22, src: LogoTwentyTwo, alt: "amcor" },
  { id: 23, src: LogoTwentyThree, alt: "amcor" },
];

const OurClients = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    autoplaySpeed: 6000,
    autoplay: true,
    loop: true,
    nextArrow: (
      <SampleNextArrow
        className={undefined}
        style={undefined}
        onClick={undefined}
      />
    ),
    prevArrow: (
      <SamplePrevArrow
        className={undefined}
        style={undefined}
        onClick={undefined}
      />
    ),
    responsive: [
      {
        breakpoint: 1112,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <section
        className=" md:py-[50px] py-[50px] bg-white"
        id="client-carousel"
      >
        <div className="container">
          <MainTitle title="Our Clients" />
          <div className="grid grid-cols-1">
            <Slider {...settings} className=" flex items-center ">
              {imageData.map((x) => (
                <div className="px-5 " key={x.id}>
                  <div className="!flex items-center  shadow-xl p-1 border border-secondary-light rounded-md ">
                    <Image
                      src={x.src}
                      alt={x.alt}
                      className="mx-auto  md:h-[10vh] object-contain "
                      loading="lazy"
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
      <section className="relative flex justify-center flex-col items-center py-[50px] px-[20px] md:px-0 bg-gray-light">
        <MainTitle title="Locations and Distributors" />

        <Map />
      </section>
    </>
  );
};

export default OurClients;
